<template>
</template>

<script>
import { appFetch, processFetchError } from '@/lib/request_utils';
import { showIpConfirmedModal, showIpTokenRefreshModal } from '@/lib/modal_utils';

export default {
    name: 'AllowIp',
    props: {
        token: String,
    },

    mounted() {
        const url = `/user/allow_ip/${this.token}`;
        appFetch(url, { method: 'POST' }).then((response) => {
            if (response.status !== 200) {
                response.json().then(data => {
                    if (data.can_retry === true) {
                        showIpTokenRefreshModal({
                            token: this.token,
                            onClose: () => this.$router.push('/'),
                        });
                    } else {
                        this.$router.replace({ name: 'page-forbidden' });
                    }
                });
            } else {
                showIpConfirmedModal({
                    title: 'IP Address Confirmed',
                });
            }
        }).catch(err => {
            processFetchError(this.$router, err);
        });
    }
}
</script>
